module.exports = __webpack_public_path__ + "media/images/users/shop-8e13eda237dc4095e184df0088e4ea0c.png";